const NOTIFICATIONS_ENABLED_KEY = 'ecos_notifications_enabled';
const NOTIFICATIONS_MUTED_UNTIL_KEY = 'ecos_notifications_muted_until';

export const isNotificationsEnabled = (): boolean => {
  const enabled = localStorage.getItem(NOTIFICATIONS_ENABLED_KEY);
  return enabled !== 'false';
};

export const setNotificationsEnabled = (enabled: boolean): void => {
  localStorage.setItem(NOTIFICATIONS_ENABLED_KEY, String(enabled));
};

export const getNotificationsMutedUntil = (): number | null => {
  const mutedUntil = localStorage.getItem(NOTIFICATIONS_MUTED_UNTIL_KEY);
  if (!mutedUntil) return null;
  
  const timestamp = parseInt(mutedUntil, 10);
  if (isNaN(timestamp)) return null;
  
  if (timestamp < Date.now()) {
    localStorage.removeItem(NOTIFICATIONS_MUTED_UNTIL_KEY);
    return null;
  }
  
  return timestamp;
};

export const muteNotificationsFor30Minutes = (): void => {
  const mutedUntil = Date.now() + 30 * 60 * 1000;
  localStorage.setItem(NOTIFICATIONS_MUTED_UNTIL_KEY, String(mutedUntil));
};

export const isNotificationsMuted = (): boolean => {
  const mutedUntil = getNotificationsMutedUntil();
  return mutedUntil !== null && mutedUntil > Date.now();
};

export const shouldShowNotification = (): boolean => {
  return isNotificationsEnabled() && !isNotificationsMuted();
};
